import { render, staticRenderFns } from "./ManageStock.vue?vue&type=template&id=3f7b8de5"
import script from "./ManageStock.vue?vue&type=script&lang=js"
export * from "./ManageStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports